import React from 'react';

type Props = {
  margin: string;
  anchor: string;
  children: ({ isVisible }: { isVisible: boolean }) => React.ReactNode;
};

type State = {
  isVisible: boolean;
  marginHeight: number;
};

export class Sticker extends React.Component<Props, State> {
  static defaultProps = {
    margin: '',
  };

  state: State = {
    isVisible: true,
    marginHeight: 0,
  };

  componentDidMount() {
    if (this.props.anchor) {
      window.addEventListener('scroll', this.onScroll);
      const marginHeight = this.computeMargins(this.props.margin);
      this.setState({ marginHeight });
    }
  }

  componentWillUnmount() {
    if (this.props.anchor) window.removeEventListener('scroll', this.onScroll);
  }

  onScroll = () => {
    const { anchor } = this.props;
    const { isVisible, marginHeight } = this.state;
    const anchorElement = document.querySelector(`#${anchor}`);
    if (anchorElement) {
      const { top: anchorY } = anchorElement.getBoundingClientRect();

      const ope = anchorY - marginHeight;

      if (ope <= 0 && isVisible) this.setState({ isVisible: false });

      if (ope >= 0 && !isVisible) this.setState({ isVisible: true });
    }
  };

  computeMargins(margin: string) {
    if (!margin) return 0;
    const element = document.getElementById(margin);
    if (!element) return 0;
    const { height } = element.getBoundingClientRect();
    return height;
  }

  render() {
    const { children } = this.props;
    const { isVisible } = this.state;

    return children({ isVisible });
  }
}
